import { combineEpics } from 'redux-observable';

import { googleAnalyticsEpic } from './google-analytics/google-analytics.epic';
import { sessionEpic } from './session/session.epic';

export const rootEpic = combineEpics(googleAnalyticsEpic, sessionEpic);
